// extracted by mini-css-extract-plugin
export default {"add":"AddOption_add__LMMDk","form":"AddOption_form__J9zjK","row":"AddOption_row__JNGgM","text":"AddOption_text__GLXFY","input":"AddOption_input__yuAmi"};